import { EVENT_ACTIONS, EVENT_CATEGORIES } from 'constants/tracking'

export enum CommonGTMEvents {
  SIMULATION_STARTED = 'simulation_started',
  PRODUCER_CONTACT_CLICKED = 'producer_contact_click'
}

export enum CampaignGTMEvents {
  TELESALES_CLICK = 'telesales_click'
}

export enum CommonTrackingParams {
  B2B_PRODUCT = 'b2b_product',
  CAMPAIGN = 'campaign',
  CREDIT_CHECK = 'requires_credit_check',
  CURRENT_LANGUAGE = 'current_language',
  CUSTOMER_TYPE = 'customer_type',
  DURATION = 'duration_ms',
  FLOW = 'flow',
  FROM_PAGE = 'from_page',
  IDENTIFICATION_METHOD = 'identification_method',
  KNOWS_METER_DETAILS = 'knows_meter_details',
  PORTAL_CONFIRMATION = 'portal_confirmation',
  REGION = 'region',
  SELECTED_PRODUCT = 'selected_product',
  SIGN_CHANNEL = 'sign_channel',
  SIMULATION_TYPE = 'simulation_type',
  SOURCE_TYPE = 'source_type',
  STEP = 'step',
  WITH_PROMO_CODE = 'with_promo_code'
}

export type EventCategory = (typeof EVENT_CATEGORIES)[keyof typeof EVENT_CATEGORIES] // describes the context the event took place in
export type EventObject = string // (snake_case) noun refers to the component or location the event took place in
export type EventAction = (typeof EVENT_ACTIONS)[keyof typeof EVENT_ACTIONS] // verb that describes what happened

export type TrackingEvent = {
  action: EventAction
  category: EventCategory
  object?: EventObject
}

export type EventNameFormat = `${EventCategory}:${EventObject}_${EventAction}` | `${EventCategory}:${EventAction}`
